export const ADD_VALUE_TO_EXPIRING_CONVOS = 'ADD_VALUE_TO_EXPIRING_CONVOS'
export const REMOVE_VALUE_FROM_EXPIRING_CONVOS = 'REMOVE_VALUE_FROM_EXPIRING_CONVOS'
